import {useMemo} from 'react';
import assert from 'assert-ts';
import type {
  Part,
  PartActionMultiThesaurus,
  PartThesaurus,
  Schema,
} from 'schemaDefinition/types';
import {visitSchemaParts} from 'schemaDefinition';

export const useThesaurusParts = (
  schema: Schema,
  partNames: PartActionMultiThesaurus['partNames'] = [],
): PartThesaurus[] => {
  return useMemo(() => {
    const parts: PartThesaurus[] = [];
    const visitor = (part: Part) => {
      if (typeof part.name === 'string' && partNames.includes(part.name)) {
        if (
          assert.soft(
            part.type === 'thesaurus',
            `useThesaurusParts: Part must be a thesaurus ${part.name}`,
          )
        ) {
          parts.push(part as PartThesaurus);
        }
      }
    };

    visitSchemaParts(schema, visitor);

    return parts;
  }, [schema, partNames]);
};
